import constants from 'constants/index'

const statusDriverSteps = (status) => {
  return constants.questionControl.QUESTION_DRIVER_SELECTED_STEPS[status]
}

export default statusDriverSteps
